import { render, staticRenderFns } from "./EmptyRoute.vue?vue&type=template&id=8dd86fb0&scoped=true&"
import script from "./EmptyRoute.vue?vue&type=script&lang=js&"
export * from "./EmptyRoute.vue?vue&type=script&lang=js&"
import style0 from "./EmptyRoute.vue?vue&type=style&index=0&id=8dd86fb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd86fb0",
  null
  
)

export default component.exports